import { registerSingleton } from 'monaco-editor/esm/vs/platform/instantiation/common/extensions.js';
import { IExtHostOutputService, ExtHostOutputService } from './extHostOutput.js';
import { IExtHostWorkspace, ExtHostWorkspace } from './extHostWorkspace.js';
import { IExtHostDecorations, ExtHostDecorations } from './extHostDecorations.js';
import { IExtHostConfiguration, ExtHostConfiguration } from './extHostConfiguration.js';
import { IExtHostCommands, ExtHostCommands } from './extHostCommands.js';
import { IExtHostDocumentsAndEditors, ExtHostDocumentsAndEditors } from './extHostDocumentsAndEditors.js';
import { IExtHostTerminalService, WorkerExtHostTerminalService } from './extHostTerminalService.js';
import { IExtHostTask, WorkerExtHostTask } from './extHostTask.js';
import { IExtHostDebugService, WorkerExtHostDebugService } from './extHostDebugService.js';
import { IExtHostSearch, ExtHostSearch } from './extHostSearch.js';
import { IExtHostStorage, ExtHostStorage } from './extHostStorage.js';
import { IExtHostTunnelService, ExtHostTunnelService } from './extHostTunnelService.js';
import { IExtHostApiDeprecationService, ExtHostApiDeprecationService } from './extHostApiDeprecationService.js';
import { IExtHostWindow, ExtHostWindow } from './extHostWindow.js';
import { IExtHostConsumerFileSystem, ExtHostConsumerFileSystem } from './extHostFileSystemConsumer.js';
import { IExtHostFileSystemInfo, ExtHostFileSystemInfo } from './extHostFileSystemInfo.js';
import { IExtHostSecretState, ExtHostSecretState } from './extHostSecretState.js';
import { IExtHostTelemetry, ExtHostTelemetry } from './extHostTelemetry.js';
import { IExtHostEditorTabs, ExtHostEditorTabs } from './extHostEditorTabs.js';
import { ExtHostLoggerService } from './extHostLoggerService.js';
import { ILoggerService } from 'monaco-editor/esm/vs/platform/log/common/log.js';
import { IExtHostVariableResolverProvider, ExtHostVariableResolverProviderService } from './extHostVariableResolverService.js';
import { IExtHostLocalizationService, ExtHostLocalizationService } from './extHostLocalizationService.js';
import { IExtHostManagedSockets, ExtHostManagedSockets } from './extHostManagedSockets.js';
registerSingleton(IExtHostLocalizationService, ExtHostLocalizationService, 1 );
registerSingleton(ILoggerService, ExtHostLoggerService, 1 );
registerSingleton(IExtHostApiDeprecationService, ExtHostApiDeprecationService, 1 );
registerSingleton(IExtHostCommands, ExtHostCommands, 0 );
registerSingleton(IExtHostConfiguration, ExtHostConfiguration, 0 );
registerSingleton(IExtHostConsumerFileSystem, ExtHostConsumerFileSystem, 0 );
registerSingleton(IExtHostDebugService, WorkerExtHostDebugService, 0 );
registerSingleton(IExtHostDecorations, ExtHostDecorations, 0 );
registerSingleton(IExtHostDocumentsAndEditors, ExtHostDocumentsAndEditors, 0 );
registerSingleton(IExtHostManagedSockets, ExtHostManagedSockets, 0 );
registerSingleton(IExtHostFileSystemInfo, ExtHostFileSystemInfo, 0 );
registerSingleton(IExtHostOutputService, ExtHostOutputService, 1 );
registerSingleton(IExtHostSearch, ExtHostSearch, 0 );
registerSingleton(IExtHostStorage, ExtHostStorage, 0 );
registerSingleton(IExtHostTask, WorkerExtHostTask, 0 );
registerSingleton(IExtHostTerminalService, WorkerExtHostTerminalService, 0 );
registerSingleton(IExtHostTunnelService, ExtHostTunnelService, 0 );
registerSingleton(IExtHostWindow, ExtHostWindow, 0 );
registerSingleton(IExtHostWorkspace, ExtHostWorkspace, 0 );
registerSingleton(IExtHostSecretState, ExtHostSecretState, 0 );
registerSingleton(IExtHostTelemetry, ExtHostTelemetry, 0 );
registerSingleton(IExtHostEditorTabs, ExtHostEditorTabs, 0 );
registerSingleton(IExtHostVariableResolverProvider, ExtHostVariableResolverProviderService, 0 );
